/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const StopIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
			fill={color}
		>
			<circle cx={25.2} cy={24.7} r={13.3} />
			<path d='M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm0 48.7C11.9 48.7 1.3 38.1 1.3 25S11.9 1.3 25 1.3 48.7 11.9 48.7 25 38.1 48.7 25 48.7z' />
		</svg>
	)
}

export default StopIcon
